// extracted by mini-css-extract-plugin
module.exports = {"component":"_30rq5","previousArrow":"_2FbgR","nextArrow":"_1l_zD","isActive":"I0Ebd"};